import React, { useState } from 'react';
import banner from '../../static/images/banner_default.png';

const CardInputFile = ({
    onChange = () => {}, 
    className = "", 
    width = "100%",
    height = "10rem",
    label = "+",
    color = "rgb(238, 238, 238)",
    styles = {},
    bg = banner
}) => {

    const id = "input_file" + Math.floor(Math.random() * 100)
    const [image, setImage] = useState(null)

    function localChange(e) {
        e.preventDefault()

        let file = e.target.files[0];
        let source = URL.createObjectURL(file)

        setImage(source)
        onChange(e.target)
    }

    return (
        <div className={"card-input-file border-radius " +className} style={styles}>
            <div className='img_input'>
                <label className='border-radius' htmlFor={id} style={{backgroundColor: color }} >{label}</label>
                <input type='file' accept='image/*' id={id} onChange={localChange}  />
            </div>


            <div className='img_bg border-radius' style={{height: height, backgroundColor: color }}>
                
                <img src={image ?? bg} className="img_cover" style={{width: width, height: height}} alt={id} />
                
            </div>
        </div>
    );
};

export default CardInputFile;